import type { FC, ReactNode } from "react";
import React from "react";
import { Box } from "@mui/material";
import ScrollableCardContent from "../ScrollableCardContent";
import HowToCreate from "../HowToCreatePostback";

type Props = {
  children: ReactNode;
};

const PostbackLayout: FC<Props> = ({ children }) => (
  <ScrollableCardContent>
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      sx={{
        minHeight: "100%",
      }}
    >
      <Box>
        {children}
      </Box>
      <Box>
        <HowToCreate />
      </Box>
    </Box>
  </ScrollableCardContent>
);

export default PostbackLayout;
